export default {
  section_title: 'Gestion des taxes',
  inherited_from_partner: 'Hérité',
  inherited_from_region: 'Défaut régional',
  reset: "Réinitialiser à l'hérité",
  form: {
    tax_name: {
      label: 'Nom de la taxe',
      tooltip: 'Nom affiché sur les reçus et factures, par exemple TVA ou GST.',
    },
    tax_behaviour: {
      label: 'Gestion des taxes',
      tooltip: 'Indique si vos prix de menu incluent déjà la taxe, ou si elle est ajoutée lors du paiement.',
      options: {
        inclusive: 'Incluse dans les prix du menu',
        exclusive: 'Ajoutée au paiement',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Taux de taxe sur les frais de livraison',
      tooltip: 'Le taux appliqué à vos propres frais de livraison, qui peut différer du taux appliqué aux aliments.',
    },
  },
  impact: {
    title: 'Modifier la gestion des taxes pour vos restaurants ?',
    affected_one: '{{count}} restaurant suit votre valeur par défaut et sera modifié.',
    affected_other: '{{count}} restaurants suivent votre valeur par défaut et seront modifiés.',
    overriding_one: '{{count}} restaurant a son propre paramètre et le conservera.',
    overriding_other: '{{count}} restaurants ont leur propre paramètre et le conserveront.',
    confirm: 'Les modifier',
  },
  buttons: {
    save: 'Enregistrer',
    cancel: 'Annuler',
  },
  toasts: {
    load_error: 'Échec du chargement des paramètres fiscaux',
    impact_error: 'Échec de la vérification des restaurants concernés',
    impact_changed_one:
      'Le nombre de restaurants concernés est passé à {{count}}. Veuillez vérifier et enregistrer à nouveau.',
    impact_changed_other:
      'Le nombre de restaurants concernés est passé à {{count}}. Veuillez vérifier et enregistrer à nouveau.',
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Les modifications ont été enregistrées',
  },
};
